// Module
var code = `<template class="message">
  <require from="./message.scss"></require>

  <span class="material-icons \${colour}" css="font-size: \${iconSize};">\${icon}</span>
  <div>
    <slot></slot>
  </div>
</template>
`;
// Exports
export default code;